import { Col } from 'antd'
import propTypes from 'global/propTypes'
import PropTypes from 'prop-types'
import React from 'react'

import './commentsTab.less'
import Comments from './Comments'
import LogbookAndContainerNotes from './LogbookAndContainerNotes'

const CommentsTab = ({
  comments,
  containerNotes,
  handlePostComment,
  isCountryUnknown,
  isLoadingContainerNotes,
  isLoadingLogbook,
  isPostingComment,
  isRequestingComments,
  logbookRemarks,
  noOfComments,
  noOfContainerNotes,
  noOfRemarks,
}) => (
  <Col span={24}>
    <div className="comments-tab__container grid-gap">
      <div>
        <Comments
          comments={comments}
          handlePostComment={handlePostComment}
          isCountryUnknown={isCountryUnknown}
          isLoading={isRequestingComments}
          isPostingComment={isPostingComment}
          noOfComments={noOfComments}
        />
      </div>
      <div>
        <LogbookAndContainerNotes
          containerNotes={containerNotes}
          isLoadingContainerNotes={isLoadingContainerNotes}
          isLoadingLogbook={isLoadingLogbook}
          logbookRemarks={logbookRemarks}
          numberOfContainerNotes={noOfContainerNotes}
          numberOfLogbookRemarks={noOfRemarks}
        />
      </div>
    </div>
  </Col>
)

CommentsTab.defaultProps = {
  containerNotes: [],
  logbookRemarks: [],
}

CommentsTab.propTypes = {
  comments: PropTypes.arrayOf(propTypes.portCallComment).isRequired,
  containerNotes: PropTypes.arrayOf(
    PropTypes.shape({
      categoryId: PropTypes.number,
      cellNumber: PropTypes.string,
      completedAt: PropTypes.string,
      containerNo: PropTypes.string,
      image: PropTypes.shape({
        fullUrl: PropTypes.string,
        thumbnailUrl: PropTypes.string,
      }),
      isComplete: PropTypes.bool,
      loggedAt: PropTypes.string.isRequired,
      remark: PropTypes.string.isRequired,
      updatedAt: PropTypes.string,
    })
  ),
  handlePostComment: PropTypes.func.isRequired,
  isCountryUnknown: PropTypes.bool.isRequired,
  isLoadingContainerNotes: PropTypes.bool.isRequired,
  isLoadingLogbook: PropTypes.bool.isRequired,
  isPostingComment: PropTypes.bool.isRequired,
  isRequestingComments: PropTypes.bool.isRequired,
  logbookRemarks: propTypes.logbookRemarks,
  noOfComments: PropTypes.number.isRequired,
  noOfContainerNotes: PropTypes.number.isRequired,
  noOfRemarks: PropTypes.number.isRequired,
}

export default CommentsTab
